import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Tracks
export const getTracks = (params) => api.get('/tracks/tracks/', { params });
export const getTrack = (id) => api.get(`/tracks/tracks/${id}/`);
export const markStarted = (id) => api.post(`/tracks/tracks/${id}/started/`);
export const logPageView = (page) => api.post('/analytics/pageview/', { page });
export const getMyPlayDates = () => api.get('/analytics/my-play-dates/');
export const markPlayed = (id) => api.post(`/tracks/tracks/${id}/played/`);
export const markSkipped = (id) => api.post(`/tracks/tracks/${id}/skipped/`);
export const rateTrack = (id, rating) => api.patch(`/tracks/tracks/${id}/rate/`, { rating });
export const loveTrack = (id) => api.patch(`/tracks/tracks/${id}/love/`);
export const markReviewed = (id) => api.post(`/tracks/tracks/${id}/mark_reviewed/`);
export const markAllReviewed = () => api.post(`/tracks/tracks/mark_all_reviewed/`);
export const getBrowserData = (params) => api.get('/tracks/browser/', { params });
export const deleteTrack = (id) => api.delete(`/tracks/tracks/${id}/`);

// Artists & Albums
export const getArtists = (params) => api.get('/tracks/artists/', { params });
export const getAlbums = (params) => api.get('/tracks/albums/', { params });
export const getGenres = () => api.get('/tracks/genres/');
export const getAlbumDetail = (id) => api.get(`/tracks/albums/${id}/`);
export const getAlbumTracks = (albumId) => api.get('/tracks/tracks/', { params: { album: albumId, ordering: 'disc_number,track_number', page_size: 200 } });
export const deleteAlbum = (id) => api.delete(`/tracks/albums/${id}/`);
export const updateAlbum = (id, data) => api.patch(`/tracks/albums/${id}/`, data);
export const mergeAsCompilation = (id) => api.post(`/tracks/albums/${id}/merge_as_compilation/`);
export const mergeAlbumInto = (id, title) => api.post(`/tracks/albums/${id}/merge_into/`, { title });

// Playlists
export const getPlaylists = (params) => api.get('/playlists/', { params: { page_size: 1000 } });
export const getPlaylist = (id) => api.get(`/playlists/${id}/`);
export const createPlaylist = (data) => api.post('/playlists/', data);
export const updatePlaylist = (id, data) => api.patch(`/playlists/${id}/`, data);
export const deletePlaylist = (id) => api.delete(`/playlists/${id}/`);
export const getPlaylistTracks = (id) => api.get(`/playlists/${id}/tracks/`);
export const addTrackToPlaylist = (id, trackId) => api.post(`/playlists/${id}/add_track/`, { track_id: trackId });
export const addTracksBulkToPlaylist = (id, trackIds) => api.post(`/playlists/${id}/add_tracks_bulk/`, { track_ids: trackIds });
export const removeTrackFromPlaylist = (id, trackId) => api.post(`/playlists/${id}/remove_track/`, { track_id: trackId });
export const reorderPlaylist = (id, order) => api.post(`/playlists/${id}/reorder/`, { order });
export const materializePlaylist = (id) => api.post(`/playlists/${id}/materialize/`);

// Import
export const importFolder = (folderPath) =>
  api.post('/import/folder/', { folder_path: folderPath });

export const importITunes = (file, loveBest = false, newOnly = false, copyFiles = false, sourcePath = '', xmlPath = '') => {
  const formData = new FormData();
  if (file) formData.append('file', file);
  formData.append('love_best_playlists', loveBest ? 'true' : 'false');
  formData.append('new_only', newOnly ? 'true' : 'false');
  formData.append('copy_files', copyFiles ? 'true' : 'false');
  formData.append('source_path', sourcePath);
  if (xmlPath) formData.append('xml_path', xmlPath);
  return api.post('/import/itunes/', formData);
};

// Stream URL
export const streamUrl = (trackId) => `${api.defaults.baseURL}/stream/${trackId}/`;

//fetch missing album art
export const fetchMissingArt = () => `/api/tracks/tracks/fetch_missing_art/`;
export const fetchTrackArt = (id) => api.post(`/tracks/tracks/${id}/fetch_art/`);
export const uploadAlbumArt = (albumId, file) => {
  const formData = new FormData();
  formData.append('image', file);
  return api.post(`/tracks/albums/${albumId}/upload_art/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

//update tracks
export const updateTrack = (id, data) => api.patch(`/tracks/tracks/${id}/`, data);
export const findOrCreateArtist = (name) => api.post(`/tracks/artists/find_or_create/`, { name });
export const findOrCreateAlbum = (name, artistId) => api.post(`/tracks/albums/find_or_create/`, { name, artist_id: artistId });
export const findOrCreateGenre = (name) => api.post(`/tracks/genres/find_or_create/`, { name });

// Remote Sync
export const getSyncStores = () => api.get('/sync/stores/');
export const createSyncStore = (data) => api.post('/sync/stores/', data);
export const updateSyncStore = (id, data) => api.patch(`/sync/stores/${id}/`, data);
export const deleteSyncStore = (id) => api.delete(`/sync/stores/${id}/`);
export const previewSync = (id) => api.get(`/sync/stores/${id}/preview/`);
export const syncStoreUrl = (id) => `${api.defaults.baseURL}/sync/stores/${id}/sync/`;

// Auth
export const loginUser = (username, password) => api.post('/users/login/', { username, password });
export const register = (username, email, password, invite_code) => api.post('/users/register/', { username, email, password, invite_code });
export const logout = () => api.post('/users/logout/');
export const getMe = () => api.get('/users/me/');

export default api;
